import { useParameterHasCorrectInputType, useGetParametersToAssignFromInput, useCreateSourceReference, useGetRefAndParameterByConsumer } from "@/frontend/hooks/parameters";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { ParameterType } from "@/types/parameterTypes";
import { Parameter } from "@/backend/models/parameter";
import { Operation } from "@/backend/models/operation";
import { OperationParameterSelect } from "./OperationParameterSelect";

export function InputParameterSelect(props: { operation: Operation, parameter: Parameter }) {
  const { operation, parameter } = props;
  const scenario = useTreeStore(state => state.containerLookup[operation.parentId]);
  const parameterHasCorrectInputType = useParameterHasCorrectInputType(parameter.inputType, operation);
  const parameters = useGetParametersToAssignFromInput(operation, scenario?.parentId)
  .filter(param => param.fieldType === parameter.fieldType && parameterHasCorrectInputType(param));
  const createSourceReference = useCreateSourceReference(parameter.id);
  const { currentReference, currentParameter } = useGetRefAndParameterByConsumer(parameter.id);

  return (
    <OperationParameterSelect
      scenario={scenario}
      parameters={parameters}
      parameterType={ParameterType.INPUT}
      inputType={parameter.inputType}
      createReference={createSourceReference}
      currentReference={currentReference}
      currentParameter={currentParameter}
      fieldType={parameter.fieldType}
    />
  );
}
